import { z } from 'zod';
import { useQuery } from 'src/shared/lib/useQuery';
import { useOrg } from 'src/shared/contexts/OrgContext';

const VersionChange = z.object({
  title: z.string(),
  description: z.string(),
});

export const VersionSchema = z.object({
  versionNumber: z.number(),
  createdAt: z.string(),
  activatedAt: z.string().nullable(),
  changes: z.array(VersionChange).optional(),
});

export type VersionType = z.infer<typeof VersionSchema>;

export function useClassificationModelVersions(modelId: string) {
  const { orgFetch } = useOrg();

  const queryKey = ['classification-model-versions', modelId];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const res = await orgFetch<VersionType[]>(`/api/v2/next-gen-models/classification/${modelId}/versions`);
      if (!res.ok) {
        throw new Error('Failed to fetch model versions');
      }
      return res.json();
    },
    enabled: !!modelId,
    staleTime: 0,
  });
}
